import { getLocale } from "../runtime";

const sv_notifybuttonlabel = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `Meddela mig`
};

const notifybuttonlabel = /** @type {(inputs?: {}, options?: {locale?: string}) => string} */ (inputs = {}, options = {}) => {
	const locale = options.locale ?? getLocale();
	if (locale === "sv") return sv_notifybuttonlabel(inputs)
	return "notifyButtonLabel";
};

export { notifybuttonlabel as "notifyButtonLabel" };